import React from 'react';
import { EmptyState } from './EmptyState';
import { gettext } from '@eventbrite/i18n';
import { NotAuthorizedIllustration as NotAuthorizedIllustrationSvg } from '@eb/eds-iconography';

export const LowResults = (props) => (
    <EmptyState illustrationType={<NotAuthorizedIllustrationSvg />} {...props}>
        {gettext("Our magic algorithm thinks you'll like these options.")}
    </EmptyState>
);
